<template>
  <div class="grupo-familiar" v-loading="loading">
    <el-row
    >
      <div>
        <div class="beneficiarios">
          <div>
            <el-button
              v-for="(beneficiario, indexB) in this.listaContatos"
              :key="indexB"
              :style="estiloBotao"
              @click="select(beneficiario)"
            >
              <div class="container">
                <div class="col1">
                  <div class="nome">
                    {{ beneficiario.nome }}
                  </div>
                  <div class="row">
                    <div class="texto">
                      {{ beneficiario.telefone }}
                    </div>
                  </div>
                </div>
                <div class="col2">
                  <div class="row">
                    <div
                      class="circle"
                      :style="{background: beneficiario.cor}"
                    >
                      <div class="abreviatura">
                        {{ beneficiario.abreviacao }}
                      </div>
                    </div>
                    <i class="material-icons-outlined" style="color:#09B531" v-if="checaPermissoesAppBeneficiario(beneficiario)">
                      mobile_friendly
                    </i>
                    <i
                      style="margin-left: 15px"
                      :style="estiloIcone"
                      class="el-icon-arrow-right"
                    />
                  </div>
                </div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { OmniMeetingResource } from '@/API'
import { mapGetters, mapState } from 'vuex'
import { mapListaByContrato } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'

export default {
  name: 'GrupoFamiliarBeneficiario',
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String
    }
  },
  watch: {
    value (newValue) {
      this.beneficiarioSelecionado = newValue
    }
  },
  data () {
    return {
      listaContratoBeneficia: [],
      listaContatos: [],
      beneficiarioSelecionado: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['contratos', 'beneficiarios']),
    ...mapState('Func53', ['paciente']),
    ...mapState('SetupApp', ['apiGrupoFamiliar']),
    estiloBotao () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloIcone () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    visualizaContratosVazios () {
      if (!this.aplicacao.grupoFamiliar) {
        return true
      }

      return this.aplicacao.grupoFamiliar.visualizaContratosVazios
    }
  },
  methods: {
    async init () {
      // Sempre que iniciado o Grupo Familiar deve iniciar com nenhum deles selecionados
      this.beneficiarioSelecionado = null

      let beneficiariosIntegracao = null
      try {
        beneficiariosIntegracao = await this.getGrupoFamiliar()
      } catch (ignored) {}
      this.loading = false

      this.listaContratoBeneficia = mapListaByContrato(
        beneficiariosIntegracao,
        this.contratos,
        this.beneficiarios,
        this.idFuncionalidade,
        this.visualizaContratosVazios
      )
      if (this.numeroContrato) {
        const filtrado = this.listaContratoBeneficia.filter((el, i) => {
          return el.contrato === this.numeroContrato
        })
        this.listaContratoBeneficia = filtrado
      }
      if (this.numeroContrato) {
        const filtrado = this.listaContratoBeneficia.filter((el, i) => {
          return el.contrato === this.numeroContrato
        })
        this.listaContratoBeneficia = filtrado
      }

      if (this.listaContratoBeneficia.length > 0) {
        this.listaContratoBeneficia[0].data = this.listaContratoBeneficia[0].data.filter(
          item => item.chaveUnica !== this.paciente.chaveUnica
        )
      }

      const permissoes = await OmniMeetingResource.permissoes()
      if (this.$route.query.contrato) {
        this.listaContatos = permissoes.data.filter((el, i) => {
          return el.numeroContrato === this.$route.query.contrato
        })
        this.listaContatos = this.listaContatos[0].beneficiarios.filter(
          item => item.chaveUnica !== this.paciente.chaveUnica
        )
      }
    },
    async getGrupoFamiliar () {
      if (this.apiGrupoFamiliar.grupoFamiliar) {
        const result = await this.apiGrupoFamiliar.grupoFamiliar({
          payload: {
            idFuncionalidade: this.idFuncionalidade
          },
          handlerErrorIgnore: true
        })

        if (!result.status) {
          return false
        }
        const { contratos } = result.data

        const invalid = contratos.filter(contrato => {
          return !contrato.beneficiarios
        })

        if (invalid.length) {
          return false
        }
        return contratos
      }
      return false
    },
    select (beneficiario) {
      // Propaga a mudança no valor
      const listabeneficiarios = this.listaContratoBeneficia.filter((el, i) => {
        return el.contrato === beneficiario.numeroContrato
      })
      beneficiario = listabeneficiarios[0].data.find((el, i) => {
        return el.chaveUnica === beneficiario.chaveUnica
      })
      this.$emit('input', beneficiario)
      this.$emit('click', beneficiario)
      this.beneficiarioSelecionado = beneficiario
    },
    checaPermissoesAppBeneficiario (beneficiario) {
      return Object.values(beneficiario.permissoesApp).some(valor => valor === true)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.container {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
}

.col1 {
  width: 80%;
  align-items: flex-start;
}

.col2 {
  padding-left: 13px;
}

.row {
  margin-top: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.circle {
  height: 35px;
  width: 35px;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nome {
  text-transform: none;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
}

.texto {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
}

.tipoBeneficiario {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
  margin-left: 5px;
  text-transform: capitalize;
}

.abreviatura {
  font-size: 17px;
  font-family: "Open Sans";
  color: #FFFFFF;
}
</style>
